import { ompApiClient } from "@app/config/axios/clients/ompApiClient";
import type { RequestConfig } from "@app/config/axios/http";
import type { ApiDepotCardMovement, ApiDepotCardMovementsFilter, ApiWsDepotCard, ApiWsDepotCardFilter } from "./types";

interface WsDepotCardsListResponse {
    depotcards: ApiWsDepotCard[];
}

interface DepotCardMovementsListResponse {
    outData: ApiDepotCardMovement[];
}

/**
 * Транспортный слой OMP — карточки УП и движения (`movements`).
 */
export const wsDepotCardsApi = {
    /**
     * Загружает карточки УП по фильтру (без серверной пагинации).
     * Запрос уходит в endpoint `stock/wsDepotcards.loadByFilter`.
     * @param params.flt фильтр {@link ApiWsDepotCardFilter}
     * @param config опции HTTP
     * @returns массив карточек
     */
    load: async (params: { flt?: ApiWsDepotCardFilter }, config?: RequestConfig): Promise<ApiWsDepotCard[]> => {
        const data = await ompApiClient.postOmega<WsDepotCardsListResponse>(
            "stock/wsDepotcards.loadByFilter",
            params,
            config,
        );
        return data.depotcards;
    },

    movements: {
        /**
         * Загружает движения по карточке депо.
         * Запрос уходит в endpoint `stock/depotcards/moves.loadByFilter`.
         */
        load: async (
            params: { flt: ApiDepotCardMovementsFilter },
            config?: RequestConfig,
        ): Promise<ApiDepotCardMovement[]> => {
            const data = await ompApiClient.postOmega<DepotCardMovementsListResponse>(
                "stock/depotcards/moves.loadByFilter",
                params,
                config,
            );
            return data.outData;
        },
    },
} as const;
